const spinner = document.getElementById('c7-loading-spinner');
const content = document.getElementById('c7-content');
const subscribe = document.getElementById('c7-subscribe');

const checkContentLoaded = () => {
  if (content) {
    const contentStyle = window.getComputedStyle(content);
    const isDone = contentStyle.minHeight === '0px';

    if (isDone) {
      spinner.style.display = 'none';
      clearInterval(checkInterval);
    }
  }
  if (subscribe) {
    const contentStyle = window.getComputedStyle(subscribe);
    const isDone = contentStyle.minHeight === '0px';

    if (isDone) {
      spinner.style.display = 'none';
      clearInterval(checkInterval);
    }
  }
};

const checkInterval = setInterval(checkContentLoaded, 200);

// update cart count
function updateMyCartCount() {
  const sourceEl = document.querySelector('#c7-cart .c7-user-nav__cart__count');
  const targetEl = document.querySelector('.cart__count');
  const cartEl = document.querySelector('.cart');

  if (sourceEl && targetEl) {
    targetEl.textContent = sourceEl.textContent;
    if (sourceEl.textContent > 0) {
      cartEl.classList.add('cart--has-items');
    }
  }
}

// Run once on page load
updateMyCartCount();

// Optional: Observe changes to update dynamically if the count changes later
const observer = new MutationObserver(updateMyCartCount);

const cartEl = document.querySelector('#c7-cart');
if (cartEl) {
  observer.observe(cartEl, { childList: true, subtree: true });
}

// update login link
function updateMyLoginLink() {
  console.log('updateMyLoginLink');
  const sourceLoginLink = document.querySelector(
    '#c7-account a.c7-user-nav__account__login, #c7-account a.c7-user-nav__account__name'
  );
  const myLoginLink = document.querySelector('.site-header__login-btn');

  if (sourceLoginLink && myLoginLink) {
    myLoginLink.href = sourceLoginLink.href;
    if (sourceLoginLink.classList.contains('c7-user-nav__account__name')) {
      let accountLabel = sourceLoginLink.innerHTML;
      accountLabel = accountLabel.replace(/<span.*?<\/span>/g, '');
      accountLabel = accountLabel.replace(/<svg.*?<\/svg>/g, '');
      accountLabel = accountLabel.replace('Hello ', '');
      myLoginLink.innerHTML = accountLabel;
    } else {
      myLoginLink.innerHTML = 'Login';
    }
  }
}

// Run once on page load
updateMyLoginLink();

// Also watch for dynamic content
const accountEl = document.querySelector('#c7-account');
if (accountEl) {
  const observer = new MutationObserver(updateMyLoginLink);
  observer.observe(accountEl, { childList: true, subtree: true });
}
